import { clsx } from "clsx"
import "./style.sass"

interface Step {
  label?: string
}
interface Props {
  steps: Step[]
  currentStep: number
  className?: string
}

export const Stepper = ({ className, steps, currentStep }: Props) => {
  return (
    <div className={clsx("stepper", className)}>
      {steps.map((step, index) => {
        const active = index + 1 <= currentStep
        return (
          <div className="stepper__wrapper" key={index}>
            <div
              className={clsx("stepper__step", {
                "stepper__step--active": active,
              })}
            >
              <span>{step.label ?? index + 1}</span>
            </div>
            {index < steps.length - 1 && <div className="stepper__dash" />}
          </div>
        )
      })}
    </div>
  )
}
